'use client'

import {ShopsPageData} from '../types'
import {useRef, useState} from 'react'

import {Shop, ShopTile} from '@/src/entities/shop'

import {ShopMapBlockLazy} from '@/src/features/common/yandex-map/ui/shop-map-block-lazy'

import {headerHeight} from '@/src/shared/utils/functions'

import * as UI from './screen.styled'

export const ShopsScreen = ({content: {shops}}: ShopsPageData) => {
  const mapRef = useRef<Nullable<HTMLDivElement>>(null)
  const [shopId, setId] = useState<Id | undefined>()
  const onSelect = (shop: Shop) => {
    setId(shop.id)

    scrollToMap(mapRef.current!)
  }

  const scrollToMap = (mapNode: HTMLElement) => {
    const el = mapNode

    try {
      window.scroll({
        top: el.offsetTop - headerHeight(),
        behavior: 'smooth',
      })
    } catch (e) {
      console.error(e)
      el!.scrollIntoView()
    }
  }

  return (
    <UI.Wrapper>
      <UI.ShopList>
        {shops.map(shop => (
          <ShopTile key={shop.title} shop={shop} onSelect={onSelect} />
        ))}
      </UI.ShopList>

      <UI.Map ref={mapRef}>
        <ShopMapBlockLazy shops={shops} shopId={shopId} onSelect={onSelect} />
      </UI.Map>
    </UI.Wrapper>
  )
}
